export class GroupMsgMember {
    groupId: number;
    resourceId: number;
    supplierId: number;
    email: string;
    name: string;
}